import { Message } from '@messageformat/react';
import { Button } from '@op/opds.opux';
import { IconDelete } from '@op/opds.opux-icons/action';
import { MouseEventHandler, ReactElement } from 'react';

interface ButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
}

const ResetButton = ({ onClick }: ButtonProps): ReactElement => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Button
        icon={IconDelete}
        iconLabel="Reset"
        iconProps={{
          size: 'default',
          style: { margin: 0 },
        }}
        className="investoracademy-reset-values-button"
        onClick={onClick}
      >
        <p className="investoracademy-reset-values-text">
          <Message id="reset_button" />
        </p>
      </Button>
    </div>
  );
};

export default ResetButton;
